module.exports = __webpack_public_path__ + "14_scivis_poster.pdf?52adf56f2eb524062acba074f7e1c626";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/14_scivis_poster.pdf
// module id = 140
// module chunks = 0